export default __webpack_public_path__ + "static/media/arrow_drop_down_black_24dp.2657d56a.svg";